import { getFirst, isValid } from 'clients/Clients';
import { getNotificationCount } from 'clients/NotifyClient';

export async function getTotalNotification({ ctx, tags }) {
  const res = await getNotificationCount({ ctx, tags });
  if (!isValid(res)) {
    return {};
  }
  return getFirst(res);
}

